import React, {Component} from 'react';
import {Provider} from 'react-redux';

import Alert from 'react-s-alert';
import Routes from '../../routes';
import store from '../../store';

import '../../common/styles.scss';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class App extends Component {
  alertConfig = {
    position: 'top-right',
    effect: 'flip',
    containerStyle: {
      zIndex: 10010,
    },
  };

  render() {
    return (
      <Provider store={store}>
        <Routes />
        <Alert
          stack={{limit: 5}}
          html
          position={'top-right'}
          effect={'flip'}
          timeout={5000}
        />
      </Provider>
    );
  }
}

export default App;
